var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResultFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116.917,
    height: 80,
    viewBox: "0 0 116.917 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}.c{fill:#f5f5f5;}.d{fill:url(#b);}.e{fill:url(#c);}.f{fill:url(#d);}.g{fill:#096a9a;}.h{fill:#e0e0e0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#b3b3b3",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3",
    stopOpacity: 0.051
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#c"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 116.917,
    height: 21.621
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 115.381,
    height: 19.764,
    transform: "translate(0.684 0.708)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 67.078,
    height: 11.763,
    transform: "translate(7.771 4.743)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M847.187,180.346a6.212,6.212,0,1,0-1.016,9.462l4.49,4.671a.3.3,0,0,0,.427.008l1.119-1.076a.3.3,0,0,0,.008-.427l-4.49-4.671A6.212,6.212,0,0,0,847.187,180.346Zm-1.4,7.508a4.443,4.443,0,1,1,.124-6.282,4.443,4.443,0,0,1-.124,6.282Z",
    transform: "translate(-746.327 -174.853)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M855.861,215.554a.388.388,0,0,0,0,.776A.388.388,0,0,0,855.861,215.554Z",
    transform: "translate(-762.769 -206.99)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M863.18,196.994a3.732,3.732,0,0,0-3.219,1.663c-.212.332.391.626.6.3a3.078,3.078,0,0,1,2.669-1.351,3.4,3.4,0,0,1,2.775,1.614c.212.35.768.032.557-.316A4.123,4.123,0,0,0,863.18,196.994Z",
    transform: "translate(-766.606 -190.919)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M847.187,175.255a6.212,6.212,0,1,0-1.016,9.462l4.49,4.671a.3.3,0,0,0,.427.008l1.119-1.076a.3.3,0,0,0,.008-.427l-4.49-4.671A6.212,6.212,0,0,0,847.187,175.255Zm-1.4,7.508a4.443,4.443,0,1,1,.124-6.282A4.443,4.443,0,0,1,845.788,182.763Z",
    transform: "translate(-746.327 -170.445)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M855.861,210.462a.388.388,0,0,0,0,.776A.388.388,0,0,0,855.861,210.462Z",
    transform: "translate(-762.769 -202.582)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M863.18,191.9a3.732,3.732,0,0,0-3.219,1.663c-.212.332.391.626.6.3a3.078,3.078,0,0,1,2.669-1.351,3.4,3.4,0,0,1,2.775,1.614c.212.35.768.032.557-.316A4.123,4.123,0,0,0,863.18,191.9Z",
    transform: "translate(-766.606 -186.51)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 116.259,
    height: 7.912,
    transform: "translate(0.658 32.262)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 116.259,
    height: 7.912,
    transform: "translate(0.658 45.538)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 116.259,
    height: 7.912,
    transform: "translate(0.658 58.813)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 116.259,
    height: 7.912,
    transform: "translate(0.658 72.088)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultFound);
export default __webpack_public_path__ + "static/media/no_result_found.54b89769d40fa34bbc210724c3e3d5fb.svg";
export { ForwardRef as ReactComponent };